import {
  IconChart, IconChat, IconContacts, IconGear, IconGrid, IconLightning, IconLink, IconMegaphone, IconPhone, IconPlug,
} from '../components/icons/Icons.jsx';
import { hasAutomation, hasCalls, hasCampaigns, hasInbox, hasShortLinks } from './tenantFeatures.js';

const STAFF = ['ADMIN', 'MANAGER'];

// Single source of truth for the workspace navigation: sidebar, phone "More" sheet and search all read it.
const SECTIONS = [
  {
    label: 'Workspace',
    items: [
      { path: '/dashboard', label: 'Dashboard', Icon: IconGrid },
      { path: '/inbox', label: 'Inbox', Icon: IconChat, when: hasInbox, badge: 'unread' },
      { path: '/contacts', label: 'Contacts', Icon: IconContacts },
      { path: '/calls', label: 'Calls', Icon: IconPhone, when: hasCalls },
    ],
  },
  {
    label: 'Engage',
    items: [
      { path: '/campaigns', label: 'Campaigns', Icon: IconMegaphone, roles: STAFF, when: hasCampaigns },
      { path: '/automations', label: 'Automations', Icon: IconLightning, roles: STAFF, when: hasAutomation },
      { path: '/links', label: 'Short links', Icon: IconLink, roles: STAFF, when: hasShortLinks },
      { path: '/reports', label: 'Reports', Icon: IconChart, roles: STAFF },
    ],
  },
  {
    label: 'Connect',
    items: [{ path: '/channels', label: 'Channels', Icon: IconPlug, roles: ['ADMIN'] }],
  },
  {
    label: 'Admin',
    items: [{ path: '/settings', label: 'Settings', Icon: IconGear, roles: ['ADMIN'] }],
  },
];

export function workspaceNav(tenant, role) {
  return SECTIONS
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => (!item.roles || item.roles.includes(role)) && (!item.when || item.when(tenant))),
    }))
    .filter((section) => section.items.length);
}

export function canOpen(path, tenant, role) {
  return workspaceNav(tenant, role).some((section) => section.items.some((item) => path === item.path || path.startsWith(`${item.path}/`)));
}

// Agents start where they work (the inbox); admins and managers start on the overview.
export function defaultWorkspacePath(tenant, role) {
  if (role === 'AGENT') {
    if (hasInbox(tenant)) return '/inbox';
    if (hasCalls(tenant)) return '/calls';
    return '/contacts';
  }
  return '/dashboard';
}
